import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="flex-1">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {t('about.title')}
            </h2>
            <div className="prose prose-lg text-gray-600">
              <p className="mb-6">
                {t('about.paragraph1')}
              </p>
              <p className="mb-6">
                {t('about.paragraph2')}
              </p>
            </div>
          </div>
          <div className="flex-1">
            <div className="relative w-full h-96 rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=advanced%20artificial%20intelligence%20system%20with%20neural%20network%20visualization%20and%20futuristic%20technology%20interface%20in%20modern%20industrial%20setting%20with%20clean%20white%20background%20and%20professional%20aesthetic&width=800&height=600&seq=about-ai-system-001&orientation=landscape"
                alt="Agentic AI system"
                title="Agentic AI system"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
